/*eslint no-empty-function: ["error", { "allow": ["functions"] }]*/
import { AppConstants } from '../../../utils/AppConstants';
import { RoutingHelper } from '../../../utils/RoutingHelper';

// Error codes and messages can be found in payment-api repository
export const shouldAllowErrorRetry = (
  statusCode: boolean | number | undefined
) => {
  if (!statusCode) {
    return true;
  }

  switch (statusCode) {
    case 500:
    case 501:
    case 502:
    case 503:
    case 504:
    case 505:
    case 529:
      return true;
    default:
      return false;
  }
};

export const errorHeader = (
  statusCode: boolean | number | undefined,
  header: string
) => {
  switch (statusCode) {
    case 522:
      return 'Kontakta oss';
    default:
      return header;
  }
};

export const errorFunctionalityHandlerTemporary = (
  statusCode: number | boolean | undefined,
  shouldAllowRetry: boolean,
  productName: string
) => {
  const reloadPage = () => {
    window.location.reload();
    window.scrollTo(0, 0);
  };
  const goToProductPage = () => {
    window.location.href = RoutingHelper.resolveFirstPageUrlPath(productName);
  };
  const goToCustomerServicePage = () => {
    window.location.href = '/privat/kundservice';
  };
  const goToCallMeCustomerServicePage = () =>{
    window.location.href = '/privat/kundservice/ring-upp-mig-underhall';
  }
  const goToStartPage = () => {
    window.location.href = '/';
  };

  switch (statusCode) {
    case 506:
    case 522:
    case 525:
    case 526: {
      return {
        primaryButtonLabel: shouldAllowRetry ? 'Försök igen' : 'Till startsidan',
        primaryButtonOnClick: shouldAllowRetry ? reloadPage : goToStartPage,
        secondaryButtonLabel: null,
        secondaryButtonOnClick: () => {}
      };
    }
    case 509:
    case 516:
    case 518:
    case 528:
    case 548:
      return {
        primaryButtonLabel: shouldAllowRetry ? 'Försök igen' : 'Till startsidan',
        primaryButtonOnClick: shouldAllowRetry ? reloadPage : goToProductPage,
        secondaryButtonLabel: null,
        secondaryButtonOnClick: () => {}
      };
    case 527:
      return {
        primaryButtonLabel: shouldAllowRetry ? 'Försök igen' : 'Se ditt pris',
        primaryButtonOnClick: shouldAllowRetry ? reloadPage : goToProductPage,
        secondaryButtonLabel: null,
        secondaryButtonOnClick: () => {}
      };    
    case 529: {
      return {
        primaryButtonLabel: 'Försök igen',
        primaryButtonOnClick: reloadPage,
        secondaryButtonLabel: 'Kontakta kundtjänst',
        secondaryButtonOnClick: goToCustomerServicePage
      };
    }
    case 551: {
      return {
        primaryButtonLabel: 'Bli uppringd',
        primaryButtonOnClick: goToCallMeCustomerServicePage,
        secondaryButtonLabel: 'Till startsidan',
        secondaryButtonOnClick: goToStartPage
      };
    }
    default: {
      return {
        primaryButtonLabel: shouldAllowRetry
        ? AppConstants.getAppText('webshop.errorPage.retryBtnLabel')
        : AppConstants.getAppText('webshop.errorPage.goBackBtnLabel'),
        primaryButtonOnClick: shouldAllowRetry ? reloadPage : goToProductPage,
        secondaryButtonLabel: AppConstants.getAppText(
          'webshop.errorPage.fromStartBtnLabel'
        ),
        secondaryButtonOnClick: goToStartPage
      };
    }
  }
};

